export default "__VITE_ASSET__r_FCOZEP__"